import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import SearchForm from "../components/SearchForm";
import { GelContentContainer, HeroSearch } from "cw-styleguide-react";
import { Helmet } from "react-helmet";

class SearchView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('app.name')}</title>
          <meta name={'description'} content={this.props.t('app.description')} />
        </Helmet>
        <h1 className={'sr-only'}>{this.props.t('view.search.title')}</h1>
        <HeroSearch>
          <SearchForm
            setFilter={this.props.setFilter}
            addFilter={this.props.addFilter}
            filters={this.props.filters}
            setQuery={this.props.setQuery}
            convertFiltersToParameters={this.props.convertFiltersToParameters}
            loadApprenticeships={this.props.loadApprenticeships}
          />
        </HeroSearch>
        <GelContentContainer>
          <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation('local')(SearchView);
